/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Sanitize log input to prevent CRLF injection (CWE-117)
 * @param input - The input to sanitize
 * @returns Sanitized string safe for logging
 */
const sanitizeLogInput = (input: any): string => {
  if (input === null || input === undefined) {
    return "";
  }
  const str = typeof input === "string" ? input : String(input);
  return str.replace(/[\r\n]+/g, " ");
};

const log = (msg: string, ...rest: any) => {
  console.log(sanitizeLogInput(msg), ...rest.map(sanitizeLogInput));
};

log.error = (msg: string, ...rest: any) => {
  console.error(sanitizeLogInput(msg), ...rest.map(sanitizeLogInput));
};

log.sanitizeLogInput = sanitizeLogInput;

export default log;
